import gql from 'graphql-tag'

export default gql`mutation ycmdMessageUntrash($message_id: ID) {
	ycmdMessageUntrash(message_id: $message_id) {
		status
	}
}`
